module.exports = __webpack_public_path__ + "static/guest-user-05360d5ffe50600a943f6b17de1291cf.png";